import {routerReducer} from 'react-router-redux'
import {combineReducers} from 'redux'
import { reducer as formReducer } from 'redux-form'
import filterReducer from './filters'
import guiReducer from './gui'
import authReducer from './auth'
import institutionReducer from './institutions'


const appReducer = combineReducers({
    gui: guiReducer,
    auth: authReducer,
    filters: filterReducer,
    institutions: institutionReducer,
    routing: routerReducer,
    form: formReducer
});

const rootReducer = (state, action) => {
    return appReducer(state, action)
};

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/root.js
 **/